export type GetMailSettings = {
  start_decision_request?: GetMailSettingStartDecisionRequest;
  answer_request: GetMailSettingAnswerRequest;
  start_notification: GetMailSettingStartNotification;
};

// 開始判断依頼
export type GetMailSettingStartDecisionRequest =
  | GetMailSettingStartDecisionRequestIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingStartDecisionRequestIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
  title: string;
  body: string;
};
// 回答依頼
export type GetMailSettingAnswerRequest =
  | GetMailSettingAnswerRequestIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingAnswerRequestIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
  title: string;
  body: string;
  is_resend: boolean;
};
// 開始通知
export type GetMailSettingStartNotification =
  | GetMailSettingStartNotificationIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingStartNotificationIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
  title: string;
  body: string;
};

type GetMailSettingIsSendFalse = {
  is_send: false;
};

type GetMailTemplate = {
  id: string;
  name: string;
} | null;

// Send
export type SendMailSettings = {
  answer_request: SendMailSettingAnswerRequest;
  start_notification: SendMailSettingStartNotification;
};
// 回答依頼
export type SendMailSettingAnswerRequest =
  | SendMailSettingAnswerRequestIsSendTrue
  | SendMailSettingIsSendFalse;
// 開始通知
export type SendMailSettingStartNotification =
  | SendMailSettingStartNotificationIsSendTrue
  | SendMailSettingIsSendFalse;
type SendMailSettingAnswerRequestIsSendTrue = {
  is_send: true;
  mail_template_id: string | null;
  title: string;
  body: string;
  is_resend: boolean;
};
type SendMailSettingIsSendFalse = {
  is_send: false;
};
type SendMailSettingStartNotificationIsSendTrue = {
  is_send: true;
  mail_template_id: string | null;
  title: string;
  body: string;
};
export class MailSettingsModel {
  start_decision_request: {
    is_send: boolean;
    mail_template: GetMailTemplate;
    title: string;
    body: string;
  };
  answer_request: {
    is_send: boolean;
    mail_template: GetMailTemplate;
    title: string;
    body: string;
    is_resend: boolean;
  };
  start_notification: {
    is_send: boolean;
    mail_template: GetMailTemplate;
    title: string;
    body: string;
  };
  constructor(input?: GetMailSettings) {
    this.start_decision_request = {
      is_send:
        input &&
        input.start_decision_request &&
        input.start_decision_request.is_send
          ? input.start_decision_request.is_send
          : false,
      title:
        input &&
        input.start_decision_request &&
        input.start_decision_request.is_send
          ? input.start_decision_request.title
          : '',
      body:
        input &&
        input.start_decision_request &&
        input.start_decision_request.is_send
          ? input.start_decision_request.body
          : '',
      mail_template:
        input &&
        input.start_decision_request &&
        input.start_decision_request.is_send &&
        input.start_decision_request.mail_template
          ? input.start_decision_request.mail_template
          : null,
    };
    this.answer_request = {
      is_send: input ? input.answer_request.is_send : false,
      mail_template:
        input &&
        input.answer_request.is_send &&
        input.answer_request.mail_template
          ? input.answer_request.mail_template
          : null,
      title:
        input && input.answer_request.is_send ? input.answer_request.title : '',
      body:
        input && input.answer_request.is_send ? input.answer_request.body : '',
      is_resend:
        input && input.answer_request.is_send
          ? input.answer_request.is_resend
          : false,
    };
    this.start_notification = {
      is_send: input ? input.start_notification.is_send : false,
      title:
        input && input.start_notification.is_send
          ? input.start_notification.title
          : '',
      body:
        input && input.start_notification.is_send
          ? input.start_notification.body
          : '',
      mail_template:
        input &&
        input.start_notification.is_send &&
        input.start_notification.mail_template
          ? input.start_notification.mail_template
          : null,
    };
  }
}
